/**
 * @generated SignedSource<<25de76baf6bddf5a04ae59de53b3a21e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReadThreadPayload",
    "kind": "LinkedField",
    "name": "readThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationHistoryQuery_readThreadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversationHistoryQuery_readThreadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "69e2f626d54b868f3fd8871c7b0bb7f7",
    "id": null,
    "metadata": {},
    "name": "ConversationHistoryQuery_readThreadMutation",
    "operationKind": "mutation",
    "text": "mutation ConversationHistoryQuery_readThreadMutation(\n  $input: ReadThreadInput!\n) {\n  readThread(input: $input) {\n    clientMutationId\n    ok\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "ac8333b394500acdeeec57b2ce2140c0";

module.exports = node;
